export default () => ({
  root: {
    margin: '0 -0.8rem',
  },
});
